import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Toaster, toast } from 'sonner';
import FeedPage from './pages/FeedPage';
import UserProfile from './components/UserProfile';
import Header from './components/layout/Header';
import { useAppStore } from './stores/wpAppStore';
import * as wpApi from './services/wordpressApi';
import { isNativeApp } from './lib/isNativeApp';

function App() {
  const setCurrentUser = useAppStore((s) => s.setCurrentUser);
  const isAuthenticated = useAppStore((s) => s.isAuthenticated);
  const currentUser = useAppStore((s) => s.currentUser);
  const error = useAppStore((s) => s.error);

  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Chuyển lỗi toàn cục trong store thành toast
  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  // Chạy trong WebView của app -> đánh dấu body để CSS ẩn header/bottom-nav web
  useEffect(() => {
    if (isNativeApp()) {
      document.body.classList.add('native-app');
    }
  }, []);

  // Check if user is already logged in
  useEffect(() => {
    const checkAuth = async () => {
      if (wpApi.isLoggedIn()) {
        try {
          const user = await wpApi.getCurrentUser();
          setCurrentUser(user);
        } catch {
          // Không logout khi lỗi tạm thời (Firebase chưa hydrate xong):
          // Header sẽ tự khôi phục qua onAuthChange
        }
      }
    };
    checkAuth();
  }, [setCurrentUser]);

  // Listen for user navigation events from PostCard
  useEffect(() => {
    const handleNavigate = (event: CustomEvent) => {
      const { userId } = event.detail;
      if (userId) {
        setSelectedUserId(userId);
      }
    };
    
    window.addEventListener('vncues:navigate-user' as any, handleNavigate);
    return () => {
      window.removeEventListener('vncues:navigate-user' as any, handleNavigate);
    };
  }, []);

  const handleCloseProfile = () => {
    setSelectedUserId(null);
  };

  const handleLoginRequired = () => {
    setShowLoginModal(true);
  };

  return (
    <div className="app-layout">
      <Header />
      <main className="app-main">
        <div className="app-content">
          {selectedUserId ? (
            <UserProfile 
              userId={selectedUserId}
              currentUserId={currentUser?.uid || null}
              onBack={handleCloseProfile}
              onLoginRequired={handleLoginRequired}
            />
          ) : (
            <FeedPage onUserClick={(userId) => setSelectedUserId(userId)} />
          )}
        </div>
      </main>
      <Toaster
        theme="dark"
        position="top-center"
        gap={8}
        toastOptions={{
          duration: 3000,
          style: { fontFamily: 'inherit' },
          classNames: {
            toast: 'vncues-toast',
          },
        }}
      />
    </div>
  );
}

export default App;
